const productTypeToReviewTypeMap = {
  APP: 'APP',
  THEME: 'THEME',
  MODULE: 'MODULE',
  AGENT: 'AGENT',
  SOLUTIONS_PARTNER_PROFILE: 'PROFILE',
  WORKFLOW_TEMPLATE: 'WORKFLOW_TEMPLATE'
};
export function getReviewTypeFromProductType(productType) {
  return productTypeToReviewTypeMap[productType];
}